import { BaseApiClient } from './base-client'
import { companiesClient } from './companies.client'
import { authClient } from './auth.client'
import { agentsApiClient } from './agents.client'
import { elevenLabsApiClient } from './elevenlabs.client'
import { knowledgeApiClient } from './knowledge.client'

/**
 * Registry for managing authentication tokens across all API clients
 * Implements the Registry pattern to centralize auth token management
 */
class ApiClientRegistry {
  private clients: BaseApiClient[] = []

  constructor() {
    // Register all API clients
    this.register(companiesClient)
    this.register(authClient)
    this.register(agentsApiClient)
    this.register(elevenLabsApiClient)
    this.register(knowledgeApiClient)
  }

  /**
   * Register an API client with the registry
   * @param client - The API client to register
   */
  register(client: BaseApiClient): void {
    if (!this.clients.includes(client)) {
      this.clients.push(client)
    }
  }

  /**
   * Set authentication token for all registered clients
   * @param token - The authentication token to set
   */
  setAuthToken(token: string | null): void {
    this.clients.forEach(client => {
      client.setAuthToken(token)
    })
  }

  /**
   * Clear authentication tokens from all registered clients
   * @param token - The authentication token to set
   */
  clearAuthTokens(): void {
    this.setAuthToken(null)
  }

  /**
   * Get the number of registered clients (useful for testing)
   * @returns The number of registered clients
   */
  getRegisteredCount(): number {
    return this.clients.length
  }
}

// Export singleton instance
export const apiClientRegistry = new ApiClientRegistry()
